module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Italic.b55ebfe6.eot";